import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../Context/AuthContext";
import dictionary from "../../util/dictionary";
export default function Header({ theme, setTheme }) {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const onLogout = () => {
    localStorage.removeItem("FuelFy@daisy");
    navigate("/");
    window.location.reload();
  };
  const toggleTheme = () => {
    const newTheme = theme === "light-theme" ? "dark-theme" : "light-theme";
    setTheme(newTheme);
  };
  // Profile dropdown state
  const [profileOpen, setProfileOpen] = useState(false);
  const toggleProfileMenu = () => setProfileOpen((prev) => !prev);
  const closeProfileMenu = () => setProfileOpen(false);
  return (
    <div className="main-header side-header sticky">
      <div className="container-fluid">
        <div className="main-header-left">
          <a className="main-logo d-lg-none" href="/">
            <img
              src={process.env.PUBLIC_URL + "/assets/img/brand/logo.png"}
              className="header-brand-img desktop-logo"
              alt="logo"
            />
            <img
              src={process.env.PUBLIC_URL + "/assets/img/brand/icon.png"}
              className="header-brand-img icon-logo"
              alt="logo"
            />
            <img
              src={process.env.PUBLIC_URL + "/assets/img/brand/logo-light.png"}
              className="header-brand-img desktop-logo theme-logo"
              alt="logo"
            />
            <img
              src={process.env.PUBLIC_URL + "/assets/img/brand/icon-light.png"}
              className="header-brand-img icon-logo theme-logo"
              alt="logo"
            />
          </a>
          <a className="main-header-menu-icon" href="#" id="mainSidebarToggle">
            <span />
          </a>
        </div>
        <div className="main-header-right">
          {/* Search */}
          <div className="dropdown d-md-flex header-search">
            <a className="nav-link icon header-search">
              <i className="fe fe-search" />
            </a>
            <div className="dropdown-menu">
              <div className="main-form-search p-2">
                <input
                  className="form-control"
                  placeholder="Search"
                  type="search"
                />
                <button className="btn">
                  <i className="fe fe-search" />
                </button>
              </div>
            </div>
          </div>
          {/* Theme toggle */}
          <div className="dropdown d-md-flex">
            <a
              className="nav-link icon layout-setting"
              onClick={toggleTheme}
              style={{ cursor: "pointer" }}
            >
              {theme === "light-theme" ? (
                <i
                  className="fe fe-moon header-icons"
                  style={{ color: "darkblue" }}
                />
              ) : (
                <i
                  className="fe fe-sun header-icons"
                  style={{ color: "white" }}
                />
              )}
            </a>
          </div>
          {/* Fullscreen */}
          <div className="dropdown d-md-flex">
            <a className="nav-link icon full-screen-link">
              <i className="fe fe-maximize fullscreen-button" />
            </a>
          </div>
          {/* Notifications */}
          <div className="dropdown main-header-notification">
            <a className="nav-link icon" href="#">
              <i className="fe fe-bell" />
              <span className="pulse bg-danger" />
            </a>
            <div className="dropdown-menu">
              <div className="header-navheading">
                <p className="main-notification-text">
                  You have 1 unread notification
                  <span className="badge badge-pill badge-primary ml-3">
                    View all
                  </span>
                </p>
              </div>
              <div className="main-notification-list">
                <div className="media">
                  <div className="main-img-user online">
                    <img
                      alt="avatar"
                      src={`${dictionary.apiHost}/img/avatar.png`}
                    />
                  </div>
                  <div className="media-body">
                    <p>
                      <strong>Elizabeth Lewis</strong> added new schedule
                      release
                    </p>
                    <span>Oct 12 10:40pm</span>
                  </div>
                </div>
              </div>
              <div className="dropdown-footer">
                <a href="#">View All Notifications</a>
              </div>
            </div>
          </div>
          {/* Profile Menu */}
          <div
            className={`dropdown main-profile-menu ${
              profileOpen ? "show" : ""
            }`}
          >
            <a
              className="main-img-user"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                toggleProfileMenu();
              }}
            >
              <img alt="avatar" src={`${dictionary.apiHost}${user.photo}`} />
            </a>
            <div className={`dropdown-menu ${profileOpen ? "show" : ""}`}>
              <div className="header-navheading">
                <h6 className="main-notification-title">
                  {user.first_name + " " + user.last_name}
                </h6>
                <p className="main-notification-text">{user.role?.role_name}</p>
              </div>
              <a
                className="dropdown-item border-top"
                href="/user/profile"
                onClick={closeProfileMenu}
              >
                <i className="fe fe-user" /> m! Profile
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => {
                  closeProfileMenu();
                  onLogout();
                }}
              >
                <i className="fe fe-power" /> Sign Out
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
